import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";

interface NeedsAttentionItem {
  id: string;
  label: string;
  severity: "critical" | "warning" | "info";
  count: number;
  path: string;
}

interface Props {
  onNavigate: (path: string) => void;
}

export default function PaletteNeedsAttention({ onNavigate }: Props) {
  const { data } = useQuery<{ needsAttention: NeedsAttentionItem[] }>({
    queryKey: ["/api/palette/context"],
    staleTime: 5 * 60 * 1000,
  });

  const items = data?.needsAttention || [];
  if (items.length === 0) return null;

  const severityColor: Record<string, string> = {
    critical: "bg-red-500",
    warning: "bg-yellow-500",
    info: "bg-blue-500",
  };

  return (
    <div className="px-3 py-2">
      <div className="uppercase text-[10px] tracking-wider text-white/40 px-1 mb-1.5 font-medium">
        Needs Attention
      </div>
      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => onNavigate(item.path)}
          className="flex items-center gap-3 w-full px-3 py-2 rounded-lg hover:bg-white/5 cursor-pointer transition-colors text-left"
        >
          <div className={`w-2 h-2 rounded-full flex-shrink-0 ${severityColor[item.severity] || severityColor.info}`} />
          <span className="text-sm text-white/70 flex-1">{item.label}</span>
          <ChevronRight className="w-4 h-4 text-white/20 flex-shrink-0" />
        </button>
      ))}
    </div>
  );
}
